<template>
  <div>
    <v-toolbar color="pink" dark>
      <v-icon>list</v-icon>
      <v-toolbar-title>Championship List</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="isAdmin">
        <template slot="activator">
          <v-btn :to="{ name: 'championship-creator' }">
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Create new championship</span>
      </v-tooltip>
    </v-toolbar>
    <v-card>
      <v-data-table :loading="ui.loading" :headers="ui.headers" :items="items" class="elevation-1" :pagination.sync="page" :total-items="page.totalItems">
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.date | formatDate }}</td>
          <td>
            <v-chip class="ma-2" :color="props.item.isRegistrationsOpen ? 'green' : 'red'" text-color="white">
              {{ props.item.isRegistrationsOpen ? "OPEN" : "CLOSED" }}
            </v-chip>
          </td>
          <td>{{ props.item.genderCategory }}</td>
          <td>{{ props.item.ageCategory }}</td>
          <td>
            <v-btn v-if="isAdmin" small :to="{ name: 'championship-editor', params: { id: props.item.id } }">Edit</v-btn>

            <v-btn small color="primary" :to="{ name: 'team-list', params: { id: props.item.id } }">View Teams</v-btn>

            <v-btn v-if="isClub && props.item.isRegistrationsOpen" small :to="{ name: 'register-team', params: { champ: props.item.id } }">New team</v-btn>
            <v-btn v-if="isAdmin" small :to="{ name: 'championship-results', params: { id: props.item.id } }">
              {{ props.item.isResultsDeclared? "Modify Results" : "Declare Results" }}
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import _ from "underscore";
import moment from "moment";
import { mapState } from "vuex";

export default {
  data: function() {
    return {
      items: [],
      page: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        hasNextPage: false,
        hasPreviousPage: false,
      },
      ui: {
        loading: false,
        headers: [
          {
            text: "Name",
            value: "name",
            sortable: false,
            align: "left",
          },
          {
            text: "Date",
            value: "date",
            sortable: false,
            align: "left",
          },
          {
            text: "Team Registrations",
            value: "isRegistrationsOpen",
            sortable: false,
            align: "left",
          },
          {
            text: "Gender Category",
            value: "genderCategory",
            sortable: false,
            align: "left",
          },
          {
            text: "Age Category",
            value: "ageCategory",
            sortable: false,
            align: "left",
          },
          {
            text: "Options",
            sortable: false,
            align: "left",
          },
        ],
      },
    };
  },
  mounted: function() {
    this.reload();
  },
  methods: {
    reload: function() {
      var me = this;
      me.ui.loading = true;
      this.$api("championships")
        .get({ page: this.page.page, pageSize: this.page.rowsPerPage })
        .then((resp) => {
          me.items = resp.items;
          me.page = _.omit(resp, "items");
        })
        .catch(function() {})
        .finally(function() {
          me.ui.loading = false;
        });
    },
  },
  filters: {
    formatDate: function(date) {
      return date ? moment(date).format("DD-MMM-YYYY") : "";
    },
    formatGender: function(i) {
      return ["Female", "Male"][i];
    },
    formatAgeGroup: function(i) {
      return ["Junior", "Sub Junior", "Senior"][i];
    },
  },
  watch: {
    "page.page": function(n, o) {
      if (n !== o) {
        this.reload();
      }
    },
    "page.rowsPerPage": function(n, o) {
      if (n !== o) {
        this.reload();
      }
    },
  },
  computed: {
    ...mapState("config", ["identity", "meta"]),
    role: function() {
      return this.identity.type;
    },
    isAdmin: function() {
      return this.role == "Administrator";
    },
    isClub: function() {
      return this.role == "Club";
    },
  },
};
</script>
